module.exports = __webpack_public_path__ + "resources/images/incasso-999ba4f21f0dba30ac890a4a2cedc085-cache.jpg";